module.exports = __webpack_public_path__ + "media/images/pages/secondary-senior-leaders/secondary_certification-f795d2e68662fabaa5adbf79cc5182b9.svg";